import * as _ from "lodash";
import * as dayjs from "dayjs";
import * as moment from "moment";
import * as hdr from "hdr-histogram-js";

interface DataItem {
  clock: number | string;
  value: number | string;
  [key: string]: any;
}

interface GroupedResult {
  clock: number;
  value: number;
  datetime: string;
}

type GroupByInterval = (
  data: DataItem[],
  intervalInMinutes: number,
  fator?: number,
) => GroupedResult[] | DataItem[];

interface TrafficDataItem {
  value: number;
  [key: string]: any;
}

const roundToIntervalEnd = (
  timestamp: number,
  intervalInMinutes: number,
): number => {
  const duration = moment.duration(intervalInMinutes, "minutes").asSeconds();
  return Math.floor((timestamp + duration) / duration) * duration;
};

export const groupByInterval: GroupByInterval = (
  data,
  intervalInMinutes,
  fator = 1,
) => {
  if (!Array.isArray(data) || data.length === 0) return data;
  const groupData = (array: DataItem[]): GroupedResult[] => {
    return _.chain(array)
      .groupBy((item: DataItem) =>
        roundToIntervalEnd(parseInt(item.clock as string), intervalInMinutes),
      )
      .map((values: DataItem[], key: string) => ({
        clock: parseInt(key),
        value: _.sumBy(
          values,
          (item: DataItem) =>
            parseFloat(item?.value as string) / (intervalInMinutes * fator),
        ),
        datetime: dayjs(parseInt(key) * 1000).format("YYYY-MM-DD HH:mm:ss"),
      }))
      .value();
  };

  return groupData(data);
};

export function calculate_95th(data: TrafficDataItem[]): number {
  const histogram: hdr.Histogram = hdr.build();
  data.map((a: TrafficDataItem) => {
    histogram.recordValue(a.value);
  });
  return histogram.getValueAtPercentile(95);
}

export function convertBpsUnit(value: string): string {
  let valInt = parseInt(value);
  const units = ["bps", "Kbps", "Mbps", "Gbps", "Tbps"];
  let unitIndex = 0;

  while (valInt >= 1000 && unitIndex < units.length - 1) {
    valInt = valInt / 1000;
    unitIndex++;
  }

  return `${valInt.toFixed(2)} ${units[unitIndex]}`;
}

export function convertBitsToBytes(bits: number | string): string {
  let bytes = parseFloat(typeof bits === "string" ? bits : bits.toString()) / 8;
  let prefixes = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let index = 0;

  while (bytes >= 1000 && index < prefixes.length - 1) {
    bytes /= 1000;
    index++;
  }

  return `${bytes.toFixed(2)} ${prefixes[index]}`;
}
